import script from "./WelcomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./WelcomeView.vue?vue&type=script&setup=true&lang=js"

import "./WelcomeView.vue?vue&type=style&index=0&id=d7f179de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7f179de"]])

export default __exports__